/**
 * Register the TARU service worker for offline shell + install prompt.
 * Safe in dev, production, and inside iframe previews.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Wait until the page is fully loaded so registration doesn't compete with critical resources.
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Notify listeners about update lifecycle
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              // A new SW is waiting — dispatch event so InstallPWAPrompt / UpdateToast can react.
              window.dispatchEvent(new CustomEvent("taru:sw-update-ready", { detail: reg }));
            }
          });
        });
      })
      .catch(() => {
        // Silently ignore; the app still works without SW.
      });
  });

  // Auto-reload when the new SW takes over
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

export function skipWaitingAndReload() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.getRegistration().then((reg) => {
    if (reg && reg.waiting) reg.waiting.postMessage("SKIP_WAITING");
  });
}
